export function clone (object, defaultValue = {}) {
    try {
        return typeof structuredClone != 'undefined'
            ? structuredClone(object)
            : JSON.parse(JSON.stringify(object))
    } catch (err) {
        console.log(err)
        return defaultValue
    }
}